import React from 'react'
import './AboutAuth.css'

const AboutAuth = () => {
  return (
    <div className='about-auth'>
        <h1>Join the Stack Overflow community</h1>
        <h3>Get unstuck --- Ask a question</h3>
        <h3>Use features like voting and commenting</h3>
        <h3>Save your favorite tags, filters and questions</h3>
        <h3>Earn reputation and badges</h3>
        <p>Collaborate and share knowledge with a private group for</p>
        <p className='team'> <a href="/">Get Stack Overflow for Teams free for upto to 50 users.</a> </p>

    </div>
  )
}

export default AboutAuth